import CardsList from "@/components/cardsList";
import { ONEMIND_NDT_CONSTANTS } from "./constants";
import { Text, Stack } from "@chakra-ui/react";
import { useTextVariants } from "@/theme/components/useSectionHeading";

const OfferingsComponent = () => {
  const TextVariant = useTextVariants();
  return (
    <Stack spacing={6} align={"center"}>
      <CardsList
        columns={{ base: 1, sm: 3 }}
        title={ONEMIND_NDT_CONSTANTS.title}
        list={ONEMIND_NDT_CONSTANTS.list}
        spacing={{ base: 8, md: 16 }}
      />
      <Text variant={TextVariant} color="text.100">
        {ONEMIND_NDT_CONSTANTS.conclusion}
      </Text>
    </Stack>
  );
};

export default OfferingsComponent;
